var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasskeyIcloudKeychain24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.1016 3.2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29781 16.6111C5.35558 16.6831 5.32084 16.7987 5.29908 16.7922L4.71973 17.3692C4.59406 17.4591 4.46892 17.4536 4.34639 17.3793L2.97317 15.9432C2.93948 15.8948 2.91637 15.8442 2.91108 15.7898V8.72877C1.21014 8.08256 0 6.43655 0 4.51014C0 2.05006 1.97352 0.0473292 4.42234 0C3.03965 1.01091 2.14084 2.64507 2.14084 4.48755C2.14084 6.58263 3.30306 8.40835 5.01734 9.35471V15.9019H5.01779C5.01749 15.9121 5.01734 15.9224 5.01734 15.9326C5.01734 16.1973 5.14398 16.4197 5.29781 16.6111Z",
    fill: "url(#pk_icloud_yellow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1952 3.2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29774 16.6111C5.3555 16.6831 5.32077 16.7987 5.29901 16.7922L4.71965 17.3692C4.59399 17.4591 4.46884 17.4536 4.34631 17.3793L2.97309 15.9432C2.9394 15.8948 2.9163 15.8442 2.91101 15.7898V8.72877C1.21014 8.08256 0 6.43655 0 4.51014C0 2.05006 1.97344 0.0473292 4.42234 0C3.03958 1.01091 2.14077 2.64507 2.14077 4.48755C2.14077 6.58263 3.30298 8.40835 5.01727 9.35471V15.9019H5.01779C5.01742 15.9121 5.01727 15.9224 5.01727 15.9326C5.01727 16.1973 5.1439 16.4197 5.29774 16.6111Z",
    fill: "url(#pk_icloud_green)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.2816 3.2496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91101 8.72959C1.21014 8.08338 0 6.43744 0 4.51103C0 2.02129 2.02129 0 4.51103 0C7.0007 0 9.02206 2.02129 9.02206 4.51103C9.02206 6.61439 7.57931 8.38353 5.63031 8.88186L7.59488 10.884C7.66897 11.0018 7.66517 11.1104 7.59048 11.2102L5.66147 13.1827L7.06099 14.5973C7.17809 14.7562 7.1596 14.909 7.04191 15.0572L4.71965 17.37C4.59399 17.46 4.46892 17.4545 4.34639 17.3801L2.97317 15.944C2.9394 15.8957 2.9163 15.8451 2.91101 15.7907V8.72959ZM4.52557 1.76206C5.19071 1.76206 5.73071 2.30206 5.73071 2.96721C5.73071 3.63235 5.19071 4.17235 4.52557 4.17235C3.86042 4.17235 3.32042 3.63235 3.32042 2.96721C3.32042 2.30206 3.86042 1.76206 4.52557 1.76206Z",
    fill: "url(#pk_icloud_blue)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk_icloud_yellow",
    x1: 2.66482,
    y1: 0,
    x2: 2.66482,
    y2: 17.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk_icloud_green",
    x1: 2.66467,
    y1: 0,
    x2: 2.66467,
    y2: 17.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk_icloud_blue",
    x1: 4.51103,
    y1: 0,
    x2: 4.51103,
    y2: 17.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasskeyIcloudKeychain24);
export default __webpack_public_path__ + "static/media/icon-passkey-icloud-keychain-24.bbfb8edc65ca07de2d10b243d76cd2d7.svg";
export { ForwardRef as ReactComponent };